<script>
import HolidayWarning from "@/components/_Shared/Warnings/Holiday";

import dateMixin from "@/mixins/dateMixin";
import timeMixin from "@/mixins/timeMixin";
import numberMixin from "@/mixins/numberMixin";

export default {
  props: {
    order: {
      type: Object,
      required: true
    }
  },

  components: {
    HolidayWarning
  },

  mixins: [dateMixin, timeMixin, numberMixin]
};
</script>

<template>
  <div class="with-border">
    <div class="data pt-15 pb-15">
      <div>
        <div class="sub-title">Limpeza de {{order.schedule_event.duration | secToHours}} horas</div>
        <p
          class="mb-0"
        >DIA: {{order.schedule_event.starts_at | formatDate("DD/MM/Y [às] HH [horas]")}}</p>
        <p
          class="mt-0 mb-0"
        >com {{order.professional.account.first_name}} {{order.professional.account.last_name}}</p>
      </div>
      <div class="pricing float text-right">
        <span class="price">{{order.total | intToCurrency}}</span>
      </div>
    </div>

    <holiday-warning :day="order.schedule_event.starts_at" />
  </div>
</template>

<style scoped>
.with-border {
  border-bottom: 1px solid #ddd;
}

.data {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.pricing {
  font-size: 20px;
  font-weight: bold;
}

.pricing .price {
  font-size: 20px;
  color: var(--pink);
  white-space: nowrap;
}

.sub-title {
  font-size: 16px;
  font-weight: 700;
  text-transform: uppercase;
}

.data p {
  font-size: 13px;
  color: #666;
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/Checkout/Payment/OrderData.vue